module.exports = __webpack_public_path__ + "media/images/funding-f3c263af.png";